import validate from "/home/jcwl/project/roncoo-education-web/node_modules/nuxt/dist/pages/runtime/validate.js";
import router_45global from "/home/jcwl/project/roncoo-education-web/middleware/router.global.js";
export const globalMiddleware = [
  validate,
  router_45global
]
export const namedMiddleware = {}